<template>
  <b-modal
    v-model="editorShown"
    :title="allergy ? 'Edit Allergy' : 'Add Allergy'"
    @ok="submitAllergy"
    centered
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="secondary" @click="cancel()">
        Cancel
      </b-button>
      <b-button variant="primary" @click="ok()">
        Save
      </b-button>
    </template>
    <b-form-group
      label="Allergy Type*"
      :state="formErrors.allergyType.length == 0 ? null : false"
      :invalid-feedback="formErrors.allergyType.join(', ')"
    >
      <template v-slot:label>
        Allergy Type <span class="text-danger">*</span>
      </template>
      <v-select v-model="form.allergyType" :options="allergyTypes"></v-select>
    </b-form-group>
    <b-form-group
      label="Allergen"
      :state="formErrors.allergen.length == 0 ? null : false"
      :invalid-feedback="formErrors.allergen.join(', ')"
    >
      <template v-slot:label>
        Allergen
      </template>
      <v-select v-model="form.allergen" :options="allergens"></v-select>
      <b-input
        v-if="form.allergen && form.allergen.label.toLowerCase() == 'other'"
        v-model="form.otherAllergen"
        :state="formErrors.otherAllergen.length == 0 ? null : false"
        class="mt-2"
        maxLength="1000"
      />
    </b-form-group>
    <b-form-group label="Reaction">
      <v-select v-model="form.reaction" :options="reactions"></v-select>
      <b-input
        v-if="form.reaction && form.reaction.label.toLowerCase() == 'other'"
        v-model="form.otherReaction"
        :state="formErrors.otherReaction.length == 0 ? null : false"
        class="mt-2"
        maxLength="1000"
      />
    </b-form-group>
    <b-form-group label="Severity">
      <v-select v-model="form.severity" :options="allergySeverities"></v-select>
    </b-form-group>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { validateRequired } from "../../helpers/validation";
export default {
  name: "PatientAllergyForm",
  props: ["allergy"],
  data() {
    return {
      form: {
        allergen: null,
        reaction: null,
        allergyType: null,
        severity: null,
        otherAllergen: null,
        otherReaction: null
      },
      formErrors: {
        allergen: [],
        allergyType: [],
        otherAllergen: [],
        otherReaction: []
      }
    };
  },
  mounted() {
    if (this.allergy) {
      this.form = {
        ...this.allergy,
        allergyType: this.allergy.allergyType
          ? {
              value: this.allergy.allergyType.id,
              label: this.allergy.allergyType.name
            }
          : null,
        allergen: this.allergy.allergen
          ? {
              value: this.allergy.allergen.id,
              label: this.allergy.allergen.name
            }
          : null,
        reaction: this.allergy.reaction
          ? {
              value: this.allergy.reaction.id,
              label: this.allergy.reaction.name
            }
          : null,
        severity: this.allergy.severity
          ? {
              value: this.allergy.severity.id,
              label: this.allergy.severity.name
            }
          : null
      };
    }
  },
  methods: {
    validateAllergySubmit() {
      let withoutErrors = true;

      this.formErrors.allergyType = [];
      if (!validateRequired(this.form.allergyType)) {
        this.formErrors.allergyType.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.otherReaction = [];
      if (
        this.form.reaction &&
        this.form.reaction.label.toLowerCase() == "other" &&
        !validateRequired(this.form.otherReaction)
      ) {
        this.formErrors.otherReaction.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitAllergy(modalEvent) {
      modalEvent.preventDefault();
      const result = this.validateAllergySubmit();
      if (result) {
        const allergyData = {
          ...this.form,
          allergyType: {
            id: this.form.allergyType.value,
            name: this.form.allergyType.label
          },
          allergen: this.form.allergen
            ? {
                id: this.form.allergen.value,
                name: this.form.allergen.label
              }
            : null,
          reaction: this.form.reaction
            ? {
                id: this.form.reaction.value,
                name: this.form.reaction.label
              }
            : null,
          severity: this.form.severity
            ? {
                id: this.form.severity.value,
                name: this.form.severity.label
              }
            : null
        };
        this.$emit("ok", allergyData);
      }
    }
  },
  computed: {
    ...mapState("client", {
      allergyTypes: state =>
        state.allergyTypes.map(allergyType => ({
          value: allergyType.id,
          label: allergyType.name
        })),
      allergySeverities: state =>
        state.allergySeverities.map(allergySeverity => ({
          value: allergySeverity.id,
          label: allergySeverity.name
        })),
      allergens: state =>
        state.allergens.map(allergen => ({
          value: allergen.id,
          label: allergen.name
        })),
      reactions: state =>
        state.reactions.map(reaction => ({
          value: reaction.id,
          label: reaction.name
        }))
    }),
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
